import { useTranslation } from '@/contexts/i18n-context';
import { Button } from '@/components/button';
import styles from './nav-button.module.css';
import { TranslationKey } from '@/contexts/translations';
import clsx from 'clsx';
import { ReactNode } from 'react';

interface NavButtonPropsBase<S> {
  to: string;
  className?: string;
  type?: 'back' | 'next';
  state?: S;
}
type NavButtonProps<S> = NavButtonPropsBase<S> &
  ({ children: ReactNode; text?: never } | { text?: TranslationKey | null; children?: never });

export function NavButton<S>({
  to,
  className,
  text = 'common.previousStep',
  type = 'back',
  state,
  children,
}: NavButtonProps<S>) {
  const { t } = useTranslation();

  return (
    <Button
      className={clsx(styles.navButton, className)}
      as="a"
      to={to}
      state={state}
      variant="link"
      rightIcon={type === 'next' ? 'arrow_forward' : undefined}
      leftIcon={type === 'back' ? 'arrow_back' : undefined}
    >
      {children ?? (text === null ? null : t(text))}
    </Button>
  );
}
